// ****** We can't use craco aliases in this file because it is used in the service worker, so we have to use relative paths
import { openDatabase, fetchData, storeData, deleteData } from '../utils/indexedDB';
import { storesDB } from '../data/storesDB';
import JSEncrypt from 'jsencrypt';
import { decrypt } from '../utils/encryption';
import { RedirectType } from '../scripts/RedirectTypeCode';
import * as keyMenu from '../scripts/KeyMenu';

export function setRedirectPage(page) {
    return new Promise((resolve, reject) => {
        const stores = [storesDB.app];

        openDatabase(stores).then(database => {
            const app = { code: storesDB.app.columns.RedirectType, value: page };
            storeData(database, storesDB.app.name, app);
        }).catch(error => {
            console.log('Error in open database');
            reject(null);
        });
    })
}

export function getRedirectPage() {
    return new Promise((resolve, reject) => {
        const stores = [storesDB.app];

        openDatabase(stores).then(database => {
            fetchData(database, storesDB.app.name, storesDB.app.columns.RedirectType).then(item => {
                if (item != null) {
                    resolve(item.value);
                } else {
                    resolve(null);
                }
            });
        }).catch(error => {
            console.log('Error in open database');
            reject(null);
        });
    })
}

export function deleteRedirectPage() {
    return new Promise((resolve, reject) => {
        const stores = [storesDB.app];

        openDatabase(stores).then(database => {
            deleteData(database, storesDB.app.name, storesDB.app.columns.RedirectType).then(() => {
                resolve();
            });
        }).catch(error => {
            console.log('Error in open database');
            reject(null);
        });
    })
}

export function getPrivateKey() {
    return new Promise((resolve, reject) => {
        const stores = [storesDB.settings];

        openDatabase(stores).then(database => {
            fetchData(database, storesDB.settings.name, storesDB.settings.columns.NotificationPrivateKey).then(item => {
                if (item != null) {
                    resolve(item.value);
                } else {
                    resolve(null);
                }
            });
        }).catch(error => {
            console.log('Error in open database');
            reject(null);
        });
    })
}

export async function redirectPage() {
    const guidPage = await getRedirectPage();

    const obj = RedirectType.find(x => x.guid == guidPage)

    return obj?.page;
}

export async function redirectPageWithEncryption() {
    const privateKey = await getPrivateKey();

    if (privateKey != null) {
        const crypt = new JSEncrypt({ default_key_size: 2048 });
        crypt.setPrivateKey(decrypt(privateKey));

        let page = await getRedirectPage();

        if (page != null) {
            page = crypt.decrypt(page.replaceAll('|', '+'));
        }

        switch (parseInt(page)) {
            case RedirectType.RedirectType_RequestApprobation:
                deleteRedirectPage();
                return keyMenu.MENU_DOCUMENTS;
            default:
                return null;
        }
    }
}

export async function handleUrlRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect');

    if (redirect != null) {
        setRedirectPage(redirect);

        // Update URL without reload
        const newUrl = window.location.pathname;

        window.history.replaceState({}, '', newUrl);
    }
}